import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";
import { ContextService } from "../services/context.service";

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const contextService = inject(ContextService);

  return next(req).pipe(
    catchError(error => {
      console.log('Authentication error', error);
      if (error.status === 401) {
        console.warn('401 Unauthorized');
        router.navigate(['/access-denied'], { replaceUrl: true });
      }

      return throwError(() => error);
    })
  );
};